import * as React from "react";
import Link from "next/link";
import { useOfferMode } from "@nju/data-access-portal-offers";
import { ErrorMessage } from "@nju/form";
import { portalRoutes } from "@nju/routes";
import { IScope } from "@nju/scope";
import { A, Button, ButtonsWrapper, Heading, Separator } from "@nju/ui";
import { INumbers } from "./chooseNewNumber.machine";
import { ChooseNewNumberWidget } from "./ChooseNewNumberWidget";
import { getChooseNewNumberTextData } from "./partials";
import { IChooseNewNumberFormType } from "./types";

interface IChooseNewNumberFormProps {
  flow: IChooseNewNumberFormType;
  variant?: IScope;
  openModal?: () => void;
  handleSubmit?: () => void;
  handleSetSelectedNumber: (number: string) => void;
  handleFetchNewNumbers: () => void;
  onFinishLater?: () => void;
  isLoading: boolean;
  isLoadingSubmit?: boolean;
  errorMessage: string | undefined;
  listOfNumbers: INumbers[];
  selectedNumber: string;
  userId?: string | undefined;
}

export function ChooseNewNumberForm({
  flow,
  variant = "portal",
  openModal,
  handleSubmit,
  handleSetSelectedNumber,
  handleFetchNewNumbers,
  isLoading,
  isLoadingSubmit,
  onFinishLater,
  selectedNumber,
  errorMessage,
  listOfNumbers,
  userId,
}: IChooseNewNumberFormProps) {
  const textFlow = React.useMemo(() => {
    return getChooseNewNumberTextData({ flow, variant });
  }, [flow, variant]);
  const mode = useOfferMode();

  if (!textFlow) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  const { text } = textFlow;

  return (
    <>
      <Heading
        align={{ "@onlyMobile": "center", "@fromTablet": "left" }}
        className="font-bold mb-3 from-tablet:mb-5"
        font="ttfirs"
        tone="neutral"
        variant="h2"
      >
        {text}
      </Heading>
      {flow === "CHANGE_NUMBER" && <Separator size="m" />}
      <ChooseNewNumberWidget
        flow={flow}
        handleFetchNewNumbers={handleFetchNewNumbers}
        handleSetSelectedNumber={handleSetSelectedNumber}
        isLoading={isLoading}
        listOfNumbers={listOfNumbers}
        selectedNumber={selectedNumber}
      />
      {errorMessage && <ErrorMessage message={errorMessage} />}
      <ButtonsWrapper>
        {flow === "NEW_NUMBER" && variant !== "sales" && (
          <Link
            href={portalRoutes.mojeKonto.index.get({
              mode,
              flow: "multiOrder",
            })}
            passHref={true}
          >
            <A
              onClick={onFinishLater}
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "m",
              }}
              variant="secondary"
            >
              dokończ później
            </A>
          </Link>
        )}
        {flow === "NEW_NUMBER" && variant === "sales" && (
          <Button
            display="inline"
            onPress={openModal}
            size={{ "@onlyMobile": "s" }}
            variant="secondary"
          >
            anuluj
          </Button>
        )}
        {flow === "CHANGE_NUMBER" && (
          <Link
            href={portalRoutes.mojeKonto.mojaKarta.index.get({
              ...(variant !== "sales" && userId && { userId }),
            })}
            passHref={true}
          >
            <A
              size={{
                "@onlyMobile": "s",
              }}
              variant="secondary"
            >
              anuluj
            </A>
          </Link>
        )}
        <Button
          isLoading={isLoadingSubmit}
          onPress={handleSubmit}
          size={{ "@onlyMobile": "s" }}
          type="submit"
        >
          dalej
        </Button>
      </ButtonsWrapper>
    </>
  );
}
